export function TakeresWordmark({ compact = false, iconOnly = false }: { compact?: boolean; iconOnly?: boolean }) {
  return (
    <span className={`wordmark ${compact ? "wordmark--compact" : ""}`} aria-label="TAKERES">
      <span className="wordmark__mark" aria-hidden="true">
        <span className="wordmark__crossbar" />
        <span className="wordmark__stem" />
        <span className="wordmark__accent" />
      </span>
      {iconOnly ? null : <span className="wordmark__label">TAKERES</span>}
    </span>
  );
}
